import { render, staticRenderFns } from "./PointCourseItem.vue?vue&type=template&id=33faf56c&scoped=true&"
import script from "./PointCourseItem.vue?vue&type=script&lang=js&"
export * from "./PointCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./PointCourseItem.vue?vue&type=style&index=0&id=33faf56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33faf56c",
  null
  
)

export default component.exports